
import TitleBox from '@/components/CSS/TitleBox'
import GoodsListPage from '@/components/GoodsListPage'
import { toMoney } from '@/utils/validate'
export default {
    components: {
        TitleBox,
        GoodsListPage
    },
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 10,
                total: 0
            },
            tableData: [],
            navListItemIndex: null,
            navList: [
                {
                    label: '全部',
                    value: null
                },
                {
                    label: '待结算',
                    value: 'IN'
                },
                {
                    label: '结算成功',
                    value: 'SUCC'
                },
                {
                    label: '结算失败',
                    value: 'FAIL'
                }
            ]
        }
    },
    computed: {
        headerCellStyle() {
            return {
                backgroundColor: '#f4f4f4'
            }
        }
    },
    methods: {
        viewDetails(row) {
            this.$router.push('/account/tiXianResultDetails?from=tixian&id=' + row.id)
        },
        handleCurrentChange(page) {
            this.pageInfo.page = page
            this.getWithdrawPage()
        },
        handleSizeChange(pageSize) {
            this.pageInfo.page = 1
            this.pageInfo.pageSize = pageSize
            this.getWithdrawPage()
        },
        back() {
            this.$router.go(-1)
        },
        navListHandler(item) {
            this.navListItemIndex = item.value
            this.getWithdrawPage()
        },
        getWithdrawPage() {
            let p = {
                action: {
                    status: this.navListItemIndex
                },
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize
            }
            this.$api.withdrawPage(p).then((res) => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.pageInfo.total = res.data.total
                res.data.records.map((item) => {
                    item.amount = toMoney(item.amount)
                    item.name = '申请提现'
                    return item
                })
                this.tableData = res.data.records
            })
        }
    },
    mounted() {
        this.getWithdrawPage()
    }
}
